import { pick } from '@shared/lib/collections'
import { useRefreshQuery } from '@shared/lib/routes'

import { useDemoShiftControlStore } from './store'

interface ButtonFiltersSubmitReturn {
  setSubmit: () => Promise<void>
}

/** The navigation is forced, so Search refetches even when the filters already match the URL. */
export const useButtonFiltersSubmit = (): ButtonFiltersSubmitReturn => {
  const { refreshQuery } = useRefreshQuery()
  const demoShiftControlStore = useDemoShiftControlStore()

  const setSubmit = async (): Promise<void> => {
    const query = pick({
      ...demoShiftControlStore.getFilterParams,
      current_page: String(demoShiftControlStore.getCurrentPage),
      per_page: String(demoShiftControlStore.getPerPage),
    })

    await refreshQuery(query)
  }

  return {
    setSubmit,
  }
}
